const Icon: React.FC<IconProps> = ({
  color = "currentColor",
  width = "29px",
  height = "28px",
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 28" width={width} height={height} fill="none">
      <path d="M14.0015 10.49C14.8299 10.49 15.5015 9.81842 15.5015 8.98999C15.5015 8.16156 14.8299 7.48999 14.0015 7.48999C13.173 7.48999 12.5015 8.16156 12.5015 8.98999C12.5015 9.81842 13.173 10.49 14.0015 10.49Z" fill="#07294C"/>
      <path d="M14.0015 16.49C14.8299 16.49 15.5015 15.8184 15.5015 14.99C15.5015 14.1616 14.8299 13.49 14.0015 13.49C13.173 13.49 12.5015 14.1616 12.5015 14.99C12.5015 15.8184 13.173 16.49 14.0015 16.49Z" fill="#07294C"/>
      <path d="M14.0015 22.49C14.8299 22.49 15.5015 21.8184 15.5015 20.99C15.5015 20.1616 14.8299 19.49 14.0015 19.49C13.173 19.49 12.5015 20.1616 12.5015 20.99C12.5015 21.8184 13.173 22.49 14.0015 22.49Z" fill="#07294C"/>
    </svg>
  );
};

export default Icon;
